module.exports = __webpack_public_path__ + "img/guochan.6850608a.webp";